import { configureStore as rtkConfigureStore, Store } from '@reduxjs/toolkit';
import createSagaMiddleware, { effects } from 'redux-saga';

import { saga as csvUploadSaga } from '@occc-app/routes/Segment/components/CSVUpload/redux';
import { default as offerSaga } from '@occc-app/Offer/redux/sagas';
import { default as offersSaga } from '@occc-app/Offers/redux/sagas';

import reducer from './reducers';

function* rootSaga() {
  yield effects.fork(csvUploadSaga);
  yield effects.fork(offerSaga);
  yield effects.fork(offersSaga);
}

export const configureStore = () => {
  const sagaMiddleware = createSagaMiddleware();
  const store: Store = rtkConfigureStore({
    reducer: reducer(),
    middleware: [sagaMiddleware],
  });

  sagaMiddleware.run(rootSaga);

  return store;
};
